/** The few LSP shapes racler reads. The inner protocol is standard LSP; this is NOT a re-implementation of its schema. */
export interface LspPosition {
  line: number;
  character: number;
}
export interface LspRange {
  start: LspPosition;
  end: LspPosition;
}
export interface LspDiagnostic {
  range: LspRange;
  severity?: 1 | 2 | 3 | 4;
  code?: string | number;
  source?: string;
  message: string;
  tags?: number[];
  [key: string]: unknown;
}
export interface LspTextEdit {
  range: LspRange;
  newText: string;
}
export interface LspWorkspaceEdit {
  changes?: Record<string, LspTextEdit[]>;
  documentChanges?: Array<{ textDocument: { uri: string; version?: number | null }; edits: LspTextEdit[] } | { kind: string }>;
}
export interface LspMessageLike {
  jsonrpc: "2.0";
  id?: number | string | null;
  method?: string;
  params?: unknown;
  result?: unknown;
  error?: { code: number; message: string; data?: unknown };
}

/** One LSP session as seen by the JSON-RPC peer (the relay implements it; tests use a fake). */
export interface LspTransport {
  send(message: LspMessageLike): void;
  /** Returns an unsubscribe function. */
  onMessage(fn: (message: LspMessageLike) => void): () => void;
  /** The session ended (stopped, crashed, machine offline, connection lost). */
  onClose(fn: (reason: string) => void): () => void;
  close(): void;
}

export const LSP_SYNTHETIC_SCHEME = "racler-project";
/** Synthetic Project URI (what the browser/server see): racler-project://<projectId>/<path> */
export function syntheticUri(projectId: string, relPath: string): string {
  return `${LSP_SYNTHETIC_SCHEME}://${projectId}/${relPath.split("/").map(encodeURIComponent).join("/")}`;
}
/** Project-relative path of a synthetic URI of THIS Project, else null (other Project, external placeholder, junk). */
export function relativeFromSynthetic(projectId: string, uri: string): string | null {
  const prefix = `${LSP_SYNTHETIC_SCHEME}://${projectId}/`;
  if (!uri.startsWith(prefix)) return null;
  try {
    const rel = uri
      .slice(prefix.length)
      .split("/")
      .map(decodeURIComponent)
      .join("/");
    return rel === "" || rel.split("/").includes("..") ? null : rel;
  } catch {
    return null;
  }
}

/** LSP language id of a file (tsserver treats .tsx/.jsx specially); null = not served by the TS/JS language server. */
export function lspLanguageIdForPath(path: string): string | null {
  const ext = path.slice(path.lastIndexOf(".")).toLowerCase();
  switch (ext) {
    case ".ts":
    case ".mts":
    case ".cts":
      return "typescript";
    case ".tsx":
      return "typescriptreact";
    case ".js":
    case ".mjs":
    case ".cjs":
      return "javascript";
    case ".jsx":
      return "javascriptreact";
    default:
      return null;
  }
}

